/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateAccessRequestCrcRequest } from '../models/CreateAccessRequestCrcRequest';
import type { CreateAccessRequestRequest } from '../models/CreateAccessRequestRequest';
import type { CreateAccessRequestSSORequest } from '../models/CreateAccessRequestSSORequest';
import type { GetAllAccessRequestsResponse } from '../models/GetAllAccessRequestsResponse';
import type { GetInvitationResponse } from '../models/GetInvitationResponse';
import type { GrantAccessRequestRequest } from '../models/GrantAccessRequestRequest';
import type { InviteCRCUserRequest } from '../models/InviteCRCUserRequest';
import type { ReInviteRequest } from '../models/ReInviteRequest';
import type { RejectAccessRequestRequest } from '../models/RejectAccessRequestRequest';
import type { RevokeAccessGrantRequest } from '../models/RevokeAccessGrantRequest';
import type { RevokeInvitationRequest } from '../models/RevokeInvitationRequest';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class AccessRequestControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetAllAccessRequestsResponse
     * @throws ApiError
     */
    public accessRequestControllerv2GetAllAccessRequests(): Observable<Array<GetAllAccessRequestsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/access',
        });
    }
    /**
     * @returns GetAllAccessRequestsResponse
     * @throws ApiError
     */
    public accessRequestControllerv2GetNumberOfPendingAccessRequests(): Observable<Array<GetAllAccessRequestsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/access/count',
        });
    }
    /**
     * @param guid
     * @returns GetInvitationResponse
     * @throws ApiError
     */
    public accessRequestControllerv2GetInvitation(
        guid: string,
    ): Observable<GetInvitationResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/access/invitation/{guid}',
            path: {
                'guid': guid,
            },
        });
    }
    /**
     * @param guid
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2CreateCrcAccessRequest(
        guid: string,
        requestBody: CreateAccessRequestCrcRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/create/crc/{guid}',
            path: {
                'guid': guid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2CreateSsoAccessRequest(
        requestBody: CreateAccessRequestSSORequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/create/sso',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2CreateAccessRequest(
        requestBody: CreateAccessRequestRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param guid
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2CheckIfUserExistByGuid(
        guid: string,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/access/ifUserExist/{guid}',
            path: {
                'guid': guid,
            },
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2InviteCrcUser(
        requestBody: InviteCRCUserRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/invite',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2ReInvite(
        requestBody: ReInviteRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/reinvite',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2RevokeInvitation(
        requestBody: RevokeInvitationRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/invitation/revoke',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2RejectAccessRequest(
        requestBody: RejectAccessRequestRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/reject',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2RevokeAccessGrant(
        requestBody: RevokeAccessGrantRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/revoke-access-grant',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestControllerv2GrantAccessRequest(
        requestBody: GrantAccessRequestRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/access/grant',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
